import React, { useContext } from "react";
import classes from "./DashboardComponents.module.scss";
import { Row, Col } from "react-bootstrap";
import ButtonLink from "../UI/ButtonLink";
import { Skeleton } from "@mui/material";
import logo from '../../assets/recieveInvoice.PNG';
import { OrgIdContext, Domain } from "../../store/orgId_context";
import { useTranslation } from 'react-i18next';

const AppRecieveBox = ({}) => {
  const {sessionInfo, domain, isTrustee} = useContext(OrgIdContext);
  const { t } = useTranslation();
  return (
    <div className={classes.container} style={{display:"flex", flexDirection:"column"}}>
      <Row style={{marginBottom:"1rem"}}>
        <Col className="col-12 col-md-12 d-flex align-items-center justify-content-center mb-3 mb-md-0">
          <ButtonLink onClick={() => {window.location.href="@einvrei"}} className="px-4 py-1">
            {t("Received e-invoices")}
          </ButtonLink>
        </Col>
      </Row>
      <Row>
        <Col className="col-12 col-md-12 text-center">
          <p>
          {t("Receive domestical & international e-Invoices and archive them by regulations (optionally).")}
          </p>
        </Col>
      </Row >
      {/* {domain===Domain.EInvoices && 
      <Row className="mt-auto">
        <Col>
        {t("Current package")}: {sessionInfo?.Extended?.CurrentPackages?.IEI_Package?.PackageCode}
        </Col>
        {isTrustee && <Col className="text-right" style={{textAlign:"right"}}>
          <ButtonLink href="/packages?forservice=rei" className="px-4 py-1" style={{fontSize:"0.8rem"}}>
          {t("Change Plan")}
          </ButtonLink>
        </Col>}
      </Row>} */}
    </div>
  );
};

export default AppRecieveBox;
